<template>
  <div class="cmp-elastic-product-filters utlz-reset col-md-12">

    <transition name="slide-fade">
      <!-- BESPOKE DEPA: Changed v=if to true -->
      <div v-if="true" class="filters-container" :ref="'filters-container'">
        <!-- END BESPOKE DEPA -->

        
        <!-- BESPOKE DEPA: Changed v=if to false -->
        <a v-if="false" @click="toggleMobileFilters()" class="close-filters-btn show-mobile">
          <i class="fa fa-times"></i>
        </a>
        <!-- END BESPOKE DEPA -->

        <div v-for="(filterGroup, i) in filters" :key="'filter-group-' + i" class="filters-wrapper">
          <div class="filter-header">
            <h2>{{ filterGroup.label }}</h2>
            <!-- BESPOKE NOX-71: Added fa.caret-down -->
            <i class="dd-arrow fa fa-caret-down"></i>
            <!-- END BESPOKE NOX-71 -->
          </div>
          <div class="filter-content">
            <!-- BESPOKE NOX-71: Removed .collapsed :class binding fucntionality-->
            <ul :ref="'filter-group-list' + i">
              <!-- END BESPOKE NOX-71 -->
              <li v-for="(filterObj, id) in filterGroup.value" :key="'filter-group-item-' + id">
                <div class="checkbox-group">
                  <input type="checkbox" :id="'checkbox-filter-' + filterObj.key" @change="checkedFilter($event, { id: filterGroup.id, value: filterObj.key, elemId: 'checkbox-filter-' + filterObj.key })" :checked="filterObj.active === true">
                  <label :for="'checkbox-filter-' + filterObj.key">
                    <span class="key">
                      {{ filterObj.key }}
                    </span>
                    <span class="count">
                      ({{ filterObj.value }})
                    </span>
                  </label>
                </div>
              </li>
            </ul>
            <!-- BESPOKE NOX-71: Changed v-if to false instead of using filterGroup list length -->
            <div v-if="false" class="collapse-btns" @click="collapseList('filter-group-list' + i)">
              <!-- END BESPOKE NOX-71 -->
              <div class="show-more-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-down"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_more' }"></span>
                </span>
                <span class="total-collapsed count">({{ filterGroup.value.length - 100 }})</span>
              </div>
              <div class="show-less-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-up"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_less'}"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('elastic', ['filters']),
    ...mapGetters('elastic', ['showMobileFilters'])
  },
  methods: {
    ...mapActions('elastic', ['updateFilters', 'toggleMobileFilters']),
    checkedFilter (ev, filter) {
      const payload = {
        filterActive: ev.target.checked,
        filterId: filter.id,
        filterValue: filter.value
      };
      if (ev.target.checked) {
        document.getElementById(filter.elemId).checked = false;
        // BESPOKE DEPG
        // Set class so we can style active filters as fixed items
        $('[id="' + filter.elemId + '"]').closest('.filter-content').addClass('expanded');
        // END BESPOKE DEGP
      } else {
        // BESPOKE DEPG
        // Set class so we can style active filters as fixed items
        $('[id="' + filter.elemId + '"]').closest('.filter-content').removeClass('expanded');
        // END BESPOKE DEGP
        document.getElementById(filter.elemId).checked = true;
      }
      this.updateFilters(payload);
    },
    collapseList ($event) {
      this.$refs[$event][0].classList.toggle('collapsed');
    }
  },
  // BESPOKE DEPG
  updated () {
    $('.cmp-elastic-product-filters :checked').closest('.filter-content').addClass('expanded');
  },
  created() {
    $('.category-text').insertBefore($('.category-text').prev())
  }
  // END BESPOKE DEPG
}
</script>
<style>

</style>
